import React, { useState } from "react";
import BaseCard from "../../../components/ui/BaseCard";
import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { fetchEmploymentHistoryList } from "../../../services/api/employment";
import { UserType } from "../../../utils/enum";
import useAuth from "../../../hooks/useAuth";
import AddEmpolymentHistoryModal from "../../CompleteYourProfile/components/AddEmpolymentHistoryModal";

const Employment = () => {
  const { id: userId } = useParams();
  const { authRole } = useAuth();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedEmployment, setSelectedEmployment] = useState(null);

  const {
    data: employmentListData,
    isPending: isFetchEmploymentListLoading,
    error: isFetchEmploymentListError,
    refetch: refetchEmploymentList,
  } = useQuery({
    queryKey: ["employmentHistoryList", userId],
    queryFn: () => fetchEmploymentHistoryList(userId),
    enabled: !!userId,
  });

  const handleEditClick = (employment) => {
    setSelectedEmployment(employment);
    setIsModalOpen(true);
  };

  const handleAddClick = () => {
    setSelectedEmployment(null);
    setIsModalOpen(true);
  };

  return (
    <BaseCard className="py-2 px-8 sm:px-10 rounded-lg" elevation={1}>
      <div className="bg-light -mx-4 px-4 py-2 mt-2 mb-4 rounded-md flex justify-between items-center">
        <h6 className="text-dark font-normal">Employment</h6>
        {authRole === UserType.ADMIN && (
          <i
            className="fa-solid fa-circle-plus cursor-pointer text-lg text-secondary"
            style={{ cursor: "pointer" }}
            onClick={handleAddClick}
          ></i>
        )}
      </div>

      {employmentListData?.data?.map((employment) => (
        <div key={employment.id} className="border-b pb-2 flex justify-between items-start mb-2">
          <div>
            <h6 className="font-normal mb-1">{employment?.companyName}</h6>
            <p className="font-normal text-sm capitalize mb-1">{employment?.designation}</p>
            <p className="mb-1">
              {employment?.city}, {employment?.country}
            </p>
            <div
              className="ql-editor !min-h-0 !p-0 text-xs"
              dangerouslySetInnerHTML={{ __html: employment?.description || "" }}
            />
          </div>
          {authRole === UserType.ADMIN && (
            <i
              className="fa-light fa-pencil text-gray-900 cursor-pointer ml-4 mt-1 flex-shrink-0"
              style={{ cursor: "pointer" }}
              onClick={() => handleEditClick(employment)}
            ></i>
          )}
        </div>
      ))}

      {isModalOpen && (
        <AddEmpolymentHistoryModal
          open={isModalOpen}
          close={setIsModalOpen}
          setEmploymentHistoryList={() => refetchEmploymentList()}
          selectedEmployment={selectedEmployment}
          setSelectedEmployment={setSelectedEmployment}
          isEdit={!!selectedEmployment}
          targetUserId={userId}
        />
      )}
    </BaseCard>
  );
};

export default Employment;
